interface Iprops {
  width: number;
  height: number;
  active: boolean;
}

export const HomeIcon = ({ width, height, active }: Iprops) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {active && (
        <rect
          width={width}
          height={height}
          rx="4"
          transform="matrix(-1 0 0 1 28 0)"
          fill="#DDEDF4"
        />
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5978 4.06108C11.5975 4.06131 11.5972 4.06154 11.597 4.06177L4.66643 9.60218C4.1528 10.0158 3.76793 10.6215 3.53232 11.239C3.29664 11.8568 3.18018 12.5653 3.2866 13.2172L3.28706 13.22L4.61706 21.18L4.61744 21.1822C4.91858 22.9514 6.5999 24.3764 8.3968 24.3764H19.5968C21.403 24.3764 23.0754 22.962 23.3763 21.1813L24.7058 13.2245C24.7059 13.2237 24.7061 13.2229 24.7062 13.222C24.819 12.5682 24.7049 11.8579 24.4688 11.239C24.2325 10.6198 23.8442 10.0136 23.3247 9.60021C23.3243 9.59989 23.3239 9.59956 23.3235 9.59924L16.396 4.05124C15.0606 2.98073 12.9407 2.9825 11.5978 4.06108ZM12.5367 5.23094C13.3337 4.59031 14.6732 4.5925 15.4576 5.22147L22.3901 10.7735C22.65 10.98 22.9013 11.3384 23.0673 11.7737C23.2334 12.2091 23.2843 12.6427 23.2278 12.9682L23.227 12.9728L21.8973 20.9314C21.8973 20.9312 21.8973 20.9316 21.8973 20.9314C21.718 21.9905 20.6704 22.8764 19.5968 22.8764H8.3968C7.33408 22.8764 6.27577 21.9819 6.09636 20.9316C6.0963 20.9312 6.09623 20.9309 6.09617 20.9305L4.767 12.9755C4.76693 12.9751 4.76686 12.9746 4.76678 12.9741C4.71358 12.6462 4.7672 12.2103 4.93379 11.7737C5.10049 11.3368 5.35023 10.9778 5.60628 10.7712C5.60658 10.771 5.60688 10.7708 5.60717 10.7705L12.5351 5.23217L12.5367 5.23094ZM13.9968 16.0664C13.5826 16.0664 13.2468 16.4022 13.2468 16.8164V19.8164C13.2468 20.2306 13.5826 20.5664 13.9968 20.5664C14.411 20.5664 14.7468 20.2306 14.7468 19.8164V16.8164C14.7468 16.4022 14.411 16.0664 13.9968 16.0664Z"
        fill={active ? "#811797" : "#7B7B7B"}
      />
    </svg>
  );
};
